// Module
var code = `<div id="grid-container"></div>
`;
// Exports
export default code;